import { request_unit as originalRequestUnit } from '../original/request_unit';
import * as _ from 'lodash';
import { warranty_mk } from './warranty_mk';

export class request_unit extends originalRequestUnit {
    c_mk_to_product: KnockoutObservableArray<warranty_mk>;

    constructor(item: any){
        super(item);
        this.c_mk_to_product = <KnockoutObservableArray<warranty_mk>>this.loadRelation(item, warranty_mk, "c_mk_to_product", "array");
    }
}


